import React from 'react';
import './App.css';
import RenovationEstimator from './components/RenovationEstimator';

function App() {
  return (
    <div className="App">
      <RenovationEstimator />
    </div>
  );
}

export default App;
